import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';

const RouteTitle = ({ title, ...restProps }) => {
    useEffect(() => {
        document.title = `${title} - skyDo CMS`;
    }, [title]);

    return (
        <Route {...restProps} />
    )
}

export default RouteTitle;
